var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.4672 -0.160156H0.8528C0.381095 -0.160156 0 0.220939 0 0.692644V20.307C0 20.7787 0.381095 21.1598 0.8528 21.1598H20.4672C20.9389 21.1598 21.32 20.7787 21.32 20.307V0.692644C21.32 0.220939 20.9389 -0.160156 20.4672 -0.160156ZM18.0047 6.06262H16.3018C14.9666 6.06262 14.7081 6.69689 14.7081 7.62964V9.68435H17.8955L17.4797 12.901H14.7081V21.1598H11.3849V12.9037H8.60528V9.68435H11.3849V7.3125C11.3849 4.55956 13.0665 3.05916 15.5236 3.05916C16.7016 3.05916 17.7116 3.14711 18.0074 3.18708V6.06262H18.0047Z"}));
}

Facebook.defaultProps = {"width":"22","height":"21","viewBox":"0 0 22 21"};

module.exports = Facebook;

Facebook.default = Facebook;
